import React, { Component } from 'react'
import PropTypes from 'prop-types'

import style from '@aytm/lib/rfd-ui/styles/basic/click-outside.module.scss'

export default class ClickOutside extends Component {
  static propTypes = {
    children: PropTypes.any,
    captured: PropTypes.bool,
    onClickOutside: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.saveRefContainer = this.saveRefContainer.bind(this)
    this.handle = this.handle.bind(this)
    this.captured = 'boolean' == typeof props.captured ? props.captured : true
    this.isTouch = false
  }

  saveRefContainer(ref) {
    this.refContainer = ref
  }

  handle(event) {
    if ('touchend' === event.type) this.isTouch = true
    if ('click' === event.type && this.isTouch) return

    const { onClickOutside } = this.props
    if (!this.refContainer.contains(event.target)) onClickOutside(event)
  }

  componentDidMount() {
    document.addEventListener('click', this.handle, this.captured)
    document.addEventListener('touchend', this.handle, this.captured)
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handle, this.captured)
    document.removeEventListener('touchend', this.handle, this.captured)
  }

  render() {
    const { children, onClickOutside, ...props } = this.props
    return (
      <div ref={this.saveRefContainer} className={style.wrapper} {...props}>
        {children}
      </div>
    )
  }
}
